import { render } from "./u-item.vue?vue&type=template&id=c53ae5f0"
import script from "./u-item.vue?vue&type=script&lang=js"
export * from "./u-item.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__